import { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import { Flex } from 'antd'
import { AIChatbotFAQFragment } from 'types/graphql'

import { EllipsisButton } from 'src/components/EllipsisButton'
import { ActionItem } from 'src/govwell-ui/types'
import useDisclosure from 'src/hooks/use-disclosure'
import AnswerQuestionButton from 'src/pages/AIAssistantTrainPage/AnswerQuestionButton'
import DismissQuestionModal from 'src/pages/AIAssistantTrainPage/DismissQuestionModal'
import { QueryKey } from 'src/utils/queryClient'

type ButtonProps = {
  aiChatbotFAQ: AIChatbotFAQFragment
}

const UnansweredQuestionsTableButtons = (props: ButtonProps) => {
  const { aiChatbotFAQ } = props
  const queryClient = useQueryClient()

  const dismissModalState = useDisclosure()
  const dismissItem: ActionItem = {
    label: 'Dismiss',
    key: `${aiChatbotFAQ.id}-dismiss`,
    icon: 'FaEraser',
    onClick: dismissModalState.open,
    isDestructive: true,
  }

  const items: ActionItem[] = [dismissItem]

  const refetch = useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: [QueryKey.SearchAIChatbotFAQs] })
    await queryClient.invalidateQueries({ queryKey: [QueryKey.GetUnansweredAIChatbotFAQsCount] })
    await queryClient.invalidateQueries({ queryKey: [QueryKey.OrganizationAISettings] })
  }, [queryClient])

  return (
    <Flex gap="4px" justify="flex-end">
      <AnswerQuestionButton aiChatbotFAQ={aiChatbotFAQ} refetch={refetch} />
      <EllipsisButton items={items} />
      {dismissModalState.isOpen && (
        <DismissQuestionModal
          id={aiChatbotFAQ.id}
          onClose={dismissModalState.close}
          refetch={refetch}
        />
      )}
    </Flex>
  )
}

export default React.memo(UnansweredQuestionsTableButtons)
